import { MutableRefObject, useState } from "react";
import { UserApi } from "../../../redux/api/UserApi";
import { Popup } from "@progress/kendo-react-popup";
import { IMention } from "../../../types/User/IMention";
import useEventListener from "@use-it/event-listener";
import './Mentions.scss';

const ARROWS = {
  up: "ArrowUp",
  left: "ArrowLeft",
  right: "ArrowRight",
  down: "ArrowDown",
};

export interface IMentionsProps {
  handleOnClick: (person: IMention) => void;
  containerRef: MutableRefObject<HTMLDivElement>;
  text: string;
  companyId?: number
}

export const Mentions = ({ props }: { props: IMentionsProps }) => {
  const { handleOnClick, containerRef, text } = props;
  const { data, isLoading, isError } = UserApi.useGetMentionQuery({ text: props.text, companyId: props.companyId });
  const [scrollIndex, setScrollIndex] = useState(0);

  // console.log('Mentions', text)

  function handleNavigation(e: KeyboardEvent) {
    const defaultBehavior: ScrollIntoViewOptions = { behavior: "smooth", block: "end" };
    let idx: number;
    let mention: IMention;

    if (Object.values(ARROWS).includes(e.key)) {
      if (e.key === ARROWS.down) {
        idx = (scrollIndex + 1) % data.length;
        mention = data.at(idx);
      } else if (e.key === ARROWS.up) {
        idx = (scrollIndex - 1) % data.length;
        mention = data.at(idx);
      } else if (e.key === ARROWS.left) {
        idx = 0;
        mention = data[0];
      } else if (e.key === ARROWS.right) {
        idx = data.length - 1;
        mention = data[data.length - 1];
      }

      const focusEle = document.getElementById(
        `${mention.ID}-${mention.value}`
      );
      focusEle.scrollIntoView(defaultBehavior);
      setScrollIndex(idx);

      console.log('Scrolling to', mention.ID, mention.label)
    }

    if (e.key === "Enter") {
      e.preventDefault();
      handleOnClick(data.at(scrollIndex));
      setScrollIndex(0);
    }
  }
  useEventListener("keydown", handleNavigation);
  const iframe = document.querySelector("div.k-editor-content iframe");
  const div = iframe
    ? //@ts-ignore
    (iframe.contentDocument.querySelector("div") as HTMLElement)
    : document.body;
  useEventListener("keydown", handleNavigation, div);
  if (isLoading) return <div>Loading Suggestions</div>;
  if (isError) return <div>More characters needed</div>;
  if (data && data.length) {
    try {
      const sideLength = data ? getImageLength(data[0].img_class) : "l";
      return (
        <Popup className="mentions-popup" anchor={containerRef.current} show>
          <ul>
            {data.map((person, i) => {
              const id = `${person.ID}-${person.value}`;
              let liStyle = "flex p-1";
              const cmp =
                scrollIndex >= 0
                  ? scrollIndex
                  : (data.length - Math.abs(scrollIndex)) % data.length;
              if (data.at(i).ID === data.at(cmp).ID) {
                liStyle = "bg-green text-white " + liStyle;
              }
              return (
                <li
                  key={id}
                  id={id}
                  className={liStyle}
                  onMouseEnter={() => setScrollIndex(i)}
                >
                  <button
                    onClick={() => handleOnClick(person)}
                    className="flex text-sm"
                  >
                    {person.img && <img
                      src={person.img?.startsWith('/') ? '.' + person.img : person.img}
                      style={{ maxWidth: sideLength, maxHeight: sideLength }}
                      // width={sideLength}
                      // height={sideLength}
                      alt={person.label}
                      className="mr-1 rounded-full"
                    />}
                    <div className="flex flex-col place-content-between text-left ms-1">
                      <span>{person.label}</span>
                      <span className="text-xs opacity-70">{person.team}</span>
                    </div>
                  </button>
                </li>
              );
            })}
          </ul>
        </Popup>
      );
    } catch (e) {
      console.log(e);
      return <></>;
    }
  } else {
    return <></>;
  }
};

function getImageLength(payload: string) {
  switch (payload) {
    case "n":
      return 0;
    case "s":
      return 25;
    case "l":
      return 40;
    default:
      return 40;
  }
}
